import { connect } from 'react-redux';
import Student from '../../views/Student/Student.view';
function mapStateToProps(state) {
    return {
      classes: state.options.classes,
      levels: state.options.levels,
      user: state.user || {},
  
    }
  }
export default connect(mapStateToProps, null)(Student);